import { useEffect } from 'react';

import { useSetTriggerChatWindow } from 'state/triggerChatWindow';
import {
  useSetIsSupportPanelOpen,
  useIsSupportPanelOpen,
} from 'state/isSupportPanelOpen';
import { chatLogout } from 'genesys/genesys';

/**
 * useTriggerChatbot
 * @description A hook to that will exposed the trigger function to window object
 * so that chatbot can be accessed
 */
export const useTriggerChatbot = () => {
  const setIsSupportPanelOpened = useSetIsSupportPanelOpen();
  const setTriggerChatWindow = useSetTriggerChatWindow();
  const isSupportPanelOpen = useIsSupportPanelOpen();

  useEffect(() => {
    window.cvjq = () => {
      return {
        trigger(vaOpen, claim = {}) {
          if (!isSupportPanelOpen) {
            setIsSupportPanelOpened(true);
            setTriggerChatWindow({ vaOpen, ...claim });

            const { entry } = claim;

            if (entry) {
              window.va?.ask(entry);
            }
          } else {
            setIsSupportPanelOpened(false);
          }
        },
        logout: chatLogout,
      };
    };
  }, [setTriggerChatWindow, setIsSupportPanelOpened, isSupportPanelOpen]);
};
